module.exports = __webpack_public_path__ + "static/media/Xls.61f8cbbf.svg";